import React from 'react/addons';
import {gettext} from 'ofs/i18n';

import TextField from 'ofs/react/fields/textfield';
import ExternalAppointment from './_ExternalAppointment';
import AppointmentChoice from './_AppointmentChoice';

const messages = {
  APPOINTMENTS_AVAILABLE: gettext('Appointments available'),
};

// appointment table
const Appointments = React.createClass({

  render() {
    const model = this.props.model.appointment || this.props.model;
    const {config} = this.props;

    const appointmentOptions = model.get('appointments').map((appointment) => 
      (<AppointmentChoice config={config} 
        key={[appointment.time, appointment.appointment_type.key].join(',')} 
        model={model} 
        appointment={appointment} />)
    );

    return (
      <div className="appointment-options">
        <h5>{messages.APPOINTMENTS_AVAILABLE}</h5>
        <table className="ofs-Appointments">
          {appointmentOptions}
        </table>
        {config.admin ? <ExternalAppointment model={model} /> : null}
        {config.admin ? <TextField label="Override appointment price (admin)" name="price_override" model={model} field="price_override" adminOnly={true}/> : null}
      </div>
    );
  }
});

export default Appointments;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/Appointments.jsx
 **/